import React from 'react';
var AsyncNoAccessTooltip = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_@atlaskit/mention/no-access-tooltip" */'./main').then(function (module) {
    return {
      default: module.NoAccessTooltip
    };
  });
});
export default AsyncNoAccessTooltip;